////
/// ============================================================================
/// COMPONENT / Hamburger
/// ============================================================================
///
/// @link https://codyhouse.co/ds/components/app/animated-menu-button
/// @group components
////

export default () => {
   /* let menuBtns = document.getElementsByClassName('js-hamburger');

    if (menuBtns.length > 0) {
        for (let i = 0; i < menuBtns.length; i++) {
            initMenuBtn(menuBtns[i]);
        }

        function initMenuBtn(btn) {
            btn.addEventListener('click', (event) => {
                event.preventDefault();
                let status = !btn.classList.contains('is-state-b');

                btn.classList.toggle('is-state-b', status);

                // emit custom event
                btn.dispatchEvent(new CustomEvent('is-clicked', {detail: status}));
            });
        }
    } */

/*
    let SearchFormBtn = document.querySelector('.js-c-search_btn');
    let SearchForm = document.querySelector('.c-search-form');

    if (SearchFormBtn) {

        initMenuBtn(SearchFormBtn);
        function initMenuBtn(btn) {
            btn.addEventListener('click', (event) => {
                event.preventDefault();
                //console.log(SearchForm);
                SearchForm.classList.toggle("open");
            });
        }
    }*/


    document.querySelectorAll('.js-click-card').forEach(item => {
        item.addEventListener('click', event => {
            event.preventDefault();
            window.location = item.querySelector('a').getAttribute('href');
        });
    });
};
